/** @jsxImportSource @emotion/react */
import * as React from 'react';
import { FC } from 'react';
import { css, SerializedStyles } from '@emotion/react';


/**
 * FlexBox Component Wrappers -- this way, we don't have to declare a bunch of repeat styled components all over the
 * place.
 */

interface IFlexboxProps {
  alignItems?: 'flex-start' | 'flex-end' | 'center' | 'baseline' | 'stretch',
  justifyContent?: 'flex-start' | 'flex-end' | 'center' | 'space-between' | 'space-around' | 'space-evenly',
  flexWrap?: 'wrap' | 'nowrap' | 'wrap-reverse',
  alignContent?: 'flex-start' | 'flex-end' | 'center' | 'space-between' | 'space-around' | 'stretch',
  style?: object,
  rootCss?: SerializedStyles,
  children?: React.ReactNode,
  flexGrow?: number,
  flexShrink?: number,
  title?: string,
  /**
   * Takes the row and its contents out of tab order and hides them from assistive
   * tech — no CSS does this. Forwarded by Row only, for locking a region while a
   * dialog is detached (see layout/window/popoutLock).
   */
  inert?: boolean,
}

export const Column: FC<IFlexboxProps> = (
  props: IFlexboxProps,
) => <div css={css`  
    display:         flex;
    flex-direction:  column;
    align-items:     ${props.alignItems};
    justify-content: ${props.justifyContent};
    flex-wrap:       ${props.flexWrap};
    align-content:   ${props.alignContent};
    flex-grow:       ${props.flexGrow};
    flex-shrink:     ${props.flexShrink};
    ${props.rootCss};
  `}
          title={props.title}
          style={props.style}
>
  {props.children}
</div>;

export const Row: FC<IFlexboxProps> = (
  props: IFlexboxProps,
) => <div css={css`
    display:        flex;
    flex-direction:  row;
    align-items:     ${props.alignItems};
    justify-content: ${props.justifyContent};
    flex-wrap:       ${props.flexWrap};
    align-content:   ${props.alignContent};
    flex-grow:       ${props.flexGrow};
    flex-shrink:     ${props.flexShrink};
    ${props.rootCss};
  `}
          title={props.title}
          style={props.style}
          inert={props.inert}
>
  {props.children}
</div>;


export const ColumnReverse: FC<IFlexboxProps> = (
  props: IFlexboxProps,
) => <div css={css`
    display:         flex;
    flex-direction:  column-reverse;
    align-items:     ${props.alignItems};
    justify-content: ${props.justifyContent};
    flex-wrap:       ${props.flexWrap};
    align-content:   ${props.alignContent};
    flex-grow:       ${props.flexGrow};
    flex-shrink:     ${props.flexShrink};
    ${props.rootCss};
  `}
          title={props.title}
          style={props.style}
>
  {props.children}
</div>;

export const RowReverse: FC<IFlexboxProps> = (
  props: IFlexboxProps,
) => <div css={css`
    display:        flex;
    flex-direction:  row-reverse;
    align-items:     ${props.alignItems};
    justify-content: ${props.justifyContent};
    flex-wrap:       ${props.flexWrap};
    align-content:   ${props.alignContent};
    flex-grow:       ${props.flexGrow};
    flex-shrink:     ${props.flexShrink};s
    ${props.rootCss};
  `}
          title={props.title}
          style={props.style}
>
  {props.children}
</div>;